// extracted by mini-css-extract-plugin
module.exports = {"card":"StatsCard_card__LUu1w","title":"StatsCard_title__1znRq","number":"StatsCard_number__14yTp"};